// 定义内容
export default {
	login: {
		placeholder1: 'The user name admin or not is test',
		placeholder2: 'Password: 123456',
		placeholder3: 'Please enter the verification code',
		btnText: 'Sign in',
		link: {
			one1: 'Third party login',
			one2: 'Links',
		},
		signInText: 'welcome back!',
		copyright: {
			one5: 'Copyright: Shenzhen XXX Software Technology Co., Ltd',
			two6: 'Copyright: Shenzhen XXX software technology Guangdong ICP preparation no.05010000',
		},
	},
};
